<template>
  <div class="box-detail product">
    <div class="box-left">
      <div class="box-left-header">
        <div
          @click="$router.push({ path: '/WarrantyProducts' })"
          class="goBack c-position-static c-m-0"
        >
          <i class="el-icon-arrow-left"></i>
          <span>质保卡产品</span>
          <i class="el-icon-box"></i>
        </div>
        <div class="c-m-r-10">
          <el-tag effect="plain" v-if="formData.productState == '0'">
            {{ formatProductState(formData.productState) }}
          </el-tag>
          <el-tag effect="dark" v-else-if="formData.productState == '1'">
            {{ formatProductState(formData.productState) }}
          </el-tag>
          <el-tag effect="dark" v-else-if="formData.productState == '3'" type="success">
            {{ formatProductState(formData.productState) }}
          </el-tag>
          <el-tag effect="dark" v-else-if="formData.productState == '4'" type="danger">
            {{ formatProductState(formData.productState) }}
          </el-tag>
          <el-tag effect="dark" v-else-if="formData.productState" type="info">
            {{ formatProductState(formData.productState) }}
          </el-tag>
        </div>
      </div>
      <div class="box-left-content">
        <c-form
          :formData="formData"
          :upload="upload"
          :fields="extFields"
          :options="options"
          ref="form"
          @changeForm="osg.changeForm"
        >
          <template slot="price">
            <el-input
              type="number"
              :disabled="formData.exts.promotion !== '1'"
              placeholder="请输入"
              v-model="formData.price"
            ></el-input>
          </template>
          <template slot="years">
            <el-select v-model="formData.years" @change="changeYears" placeholder="请选择">
              <el-option
                v-for="item in options.warrantyPeriod"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <!-- <template slot="exts.promotion">
          <el-select
            v-model="formData.exts.promotion"
            @change="changeYears"
            placeholder="请选择"
            v-if="true || osg.has('WarrantyProduct,promotion')"
          >
            <el-option
              v-for="item in options['IS']"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template> -->
          <!-- <template slot="productList">
          <el-select
            v-model="formData.productList"
            @change="$forceUpdate()"
            @clear="getProduct"
            clearable
            multiple
            remote
            :remote-method="getProduct"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options.product"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template> -->
          <!-- <template slot="countryUse">
          <el-select v-model="formData.countryUse" clearable placeholder="请选择">
            <el-option
              v-for="item in options.isNational"
              :key="item.value"
              :label="item.label"
              :value="(item.value)"
            ></el-option>
          </el-select>
        </template> -->
          <!-- <template slot="orgIds">
          <el-cascader
            v-model="formData.orgIds"
            :options="options.orgs"
            :show-all-levels="false"
            :props="{
              multiple: true,
              checkStrictly: true,
              emitPath: false,
              label: 'orgName',
              value: '_id',
              children: 'orgList'
            }"
            clearable
          ></el-cascader>
        </template> -->
        </c-form>
      </div>
      <div class="box-left-footer" v-if="osg.has('WarrantyProduct,edit')">
        <el-button type="primary" @click="doSave()">提交</el-button>
        <el-button plain @click="getData">取消</el-button>
      </div>
    </div>
    <div class="box-center">
      <el-tabs v-model="activeTab" @tab-click="tabClick">
        <el-tab-pane label="适用范围" name="scope">
          <div class="box-center-tool">
            <div></div>
            <div>
              <el-button
                v-if="!formData.scope || !formData.scope.length"
                type="primary"
                size="mini"
                @click="openScope"
              >
                添加范围
              </el-button>
            </div>
          </div>
          <el-table ref="addedTable" :data="formData.scope" border class="c-m-t-10">
            <el-table-column label="省">
              <template slot-scope="scope">
                {{ formatProvinces(scope.row.province) }}
              </template>
            </el-table-column>
            <el-table-column label="市">
              <template slot-scope="scope">
                {{ formatCitys(scope.row.city) }}
              </template>
            </el-table-column>
            <el-table-column label="区" width="250" show-overflow-tooltip>
              <template slot-scope="scope" style="width:100%">
                {{ formatDistricts(scope.row.district) }}
              </template>
            </el-table-column>
            <el-table-column
              v-if="isPartnerIdsShow"
              prop="partnerIds"
              label="伙伴"
              width="250"
              show-overflow-tooltip
              :formatter="formatPartners"
            >
              <!-- <template slot-scope="scope" style="width:100%">
                {{ JSON.stringify(options.partners) }}
              </template> -->
            </el-table-column>
            <el-table-column
              fixed="right"
              width="150"
              label="操作"
              v-if="osg.has('WarrantyProductInventory,edit')"
            >
              <template slot-scope="scope">
                <el-button @click="scopeEdit(scope.row, scope.$index)" size="mini">
                  编辑
                </el-button>
                <el-button @click="scopeDelete(scope.row, scope.$index)" size="mini">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-dialog title="适用范围" :visible.sync="scope.open" @close="cancelScope">
            <el-form
              ref="scopeFormData"
              :model="scope.formData"
              :rules="rules"
              label-width="90px"
              label-position="left"
            >
              <el-form-item label="省市区" prop="area">
                <el-cascader
                  :options="area.options"
                  :props="area.props"
                  v-model="scope.formData.area"
                  collapse-tags
                  clearable
                  @change="getST"
                ></el-cascader>
              </el-form-item>
              <el-form-item label="伙伴">
                <el-select
                  @change="$forceUpdate()"
                  v-model="scope.formData.orgIds"
                  multiple
                  clearable
                >
                  <el-option
                    v-for="item in scope.serviceResource"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div slot="footer">
              <el-button type="primary" @click="addScope">确 定</el-button>
              <el-button @click="cancelScope">取 消</el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="动态" name="log">
          <div class="box-center-tool">
            <div>
              <el-date-picker
                v-model="log.searchDate"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                clearable
                @change="getLog"
                class="search-date"
              ></el-date-picker>
            </div>
            <div>
              <el-input
                placeholder="请输入标题/内容"
                v-model="log.searchValue"
                class="search-input"
                clearable
                @clear="getLog"
                @keyup.enter.native="getLog"
              >
                <el-button slot="append" icon="el-icon-search" @click="getLog"></el-button>
              </el-input>
            </div>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(log, i) in log.fpi.data" :key="i">
              <div class="activity-card-header">
                <span class="c-font-500">
                  <i class="el-icon-monitor c-w-30"></i>
                  {{ log.title }}
                </span>
                <span>{{ log.createTime }}</span>
              </div>
              <div class="activity-card-content">
                {{ log.content }}
              </div>
              <div class="activity-card-footer">
                <span>操作人：{{ log.updateUserName }}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="笔记" name="notes" v-if="false">
          <div class="box-center-tool">
            <div></div>
            <el-button
              type="primary"
              size="mini"
              @click="
                vqeditor.content = ``;
                openNote = true;
              "
            >
              创建笔记
            </el-button>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(note, i) in noteData" :key="i">
              <div class="activity-card-header">
                <span>
                  <i class="el-icon-edit-outline c-w-30"></i>
                  笔记
                </span>
                <span>{{ note.createTime }}</span>
              </div>
              <div
                class="activity-card-content-node"
                v-html="note.content"
                @click="noteMdShow(note)"
                v-if="!note.openNote"
              ></div>
              <c-editor
                v-else
                class="c-m-15"
                :formData="note"
                :value="'content'"
                ref="editor"
              ></c-editor>
              <div class="activity-card-footer">
                <span>操作人：{{ note.createUserName }}</span>
              </div>
            </div>
          </div>
          <!-- markdown编辑器 -->
          <el-dialog title="笔记" :visible.sync="openNote">
            <c-editor :formData="vqeditor" :value="'content'" ref="editor"></c-editor>
            <div slot="footer">
              <el-button type="primary" @click="saveNote">确 认</el-button>
              <el-button
                @click="
                  openNote = false;
                  vqeditor.content = '';
                "
              >
                取 消
              </el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="变更记录" name="history">
          <div
            class="box-center-content"
            v-infinite-scroll="getHistory"
            :infinite-scroll-immediate="true"
          >
            <c-modify
              :historyFpi="historyFpi"
              :fields="extFields"
              :fieldsObj="fieldsObj"
              :options="options"
              ref="modify"
            ></c-modify>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="box-right" :class="collapse ? 'box-collapse' : ''">
      <div class="box-right-header">
        <i class="el-icon-d-arrow-left" @click="collapse = false" v-if="collapse"></i>
        <i class="el-icon-d-arrow-right" @click="collapse = true" v-else></i>
      </div>
      <div class="box-right-content" v-show="!collapse">
        <!-- <el-collapse v-model="activeCollapse">
          <el-collapse-item name="1">
            <template slot="title">
              <span>依赖产品展示</span>
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of formData.dependProList" :key="i">
                <div>
                  <i class="el-icon-box card-item-logo" style="color: #606266;"></i>
                </div>
                <div>
                  <p>
                    <el-link :href="'/Product/' + item._id" target="_blank">
                      {{ item.name }}
                    </el-link>
                  </p>
                  <p>
                    <span>型号：{{ item.code }}</span>
                  </p>
                  <p>
                    <span>单位：{{ osg.codelabel('unit', item.unit) }}</span>
                  </p>
                  <p>
                    <span>价格：{{ item.price }}元</span>
                  </p>
                  <p>
                    <span>产品类型：{{ osg.codelabel('productType', item.productType) }}</span>
                  </p>
                  <p>
                    <span>
                      业务类型：{{ osg.codelabel('productBizType', item.productBizType) }}
                    </span>
                  </p>
                  <p>
                    <span>依赖产品：{{ osg.codelabelForArray('product', item.depends) }}</span>
                  </p>
                  <p>
                    <span>子产品：{{ osg.codelabelForArray('product', item.childs) }}</span>
                  </p>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item name="2">
            <template slot="title">
              <span>子产品展示</span>
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of formData.productList" :key="i">
                <div>
                  <i class="el-icon-box card-item-logo" style="color: #606266;"></i>
                </div>
                <div>
                  <p>
                    <el-link :href="'/Product/' + item._id" target="_blank">
                      {{ item.name }}
                    </el-link>
                  </p>
                  <p>
                    <span>型号：{{ item.code }}</span>
                  </p>
                  <p>
                    <span>单位：{{ osg.codelabel('unit', item.unit) }}</span>
                  </p>
                  <p>
                    <span>价格：{{ item.price }}元</span>
                  </p>
                  <p>
                    <span>产品类型：{{ osg.codelabel('productType', item.productType) }}</span>
                  </p>
                  <p>
                    <span>
                      业务类型：{{ osg.codelabel('productBizType', item.productBizType) }}
                    </span>
                  </p>
                  <p>
                    <span>依赖产品：{{ osg.codelabelForArray('product', item.depends) }}</span>
                  </p>
                  <p>
                    <span>子产品：{{ osg.codelabelForArray('product', item.childs) }}</span>
                  </p>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse> -->
      </div>
    </div>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';

export default {
  name: 'warrantyProduct',
  data() {
    window.$this = this;
    const selfAreajs = JSON.parse(JSON.stringify({ areaList: this.osg.areaList }));
    if (selfAreajs.areaList[0].value != '000000') {
      selfAreajs.areaList.unshift({ label: '全国', value: '000000' });
    }
    // import areaList from '../../resources/js/areaList.js';
    const selfAreaList = JSON.parse(JSON.stringify(this.osg.areaObj));
    if (!selfAreaList.province_list['000000']) {
      selfAreaList.province_list['000000'] = '全国';
    }
    return {
      id: null,
      tenantId: '',
      type: '',
      typeName: '产品',
      collapse: true,
      activeCollapse: '1',
      formData: { exts: {}, productList: [] },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      fieldsObj: {},
      options: {
        codecfg_IS: { codeId: 'IS' },
        codecfg_warrantyProductCard: { codeId: 'warrantyProductCard' }, //质保年限
        codecfg_warrantyPeriod: { codeId: 'warrantyPeriod' }, //质保卡产品名称
        codecfg_fixedLifePrice: { codeId: 'fixedLifePrice' } //质保卡年限固定价格表
      },
      rules: this.$util.rules,
      // 日志
      log: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      historyFpi: {
        page: 1,
        rows: 0,
        data: [],
        busy: false
      },
      noteData: [],
      openNote: false,
      vqeditor: this.$util.vqeditor,
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: window.$this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      activeTab: 'scope',
      // 适用范围
      scope: {
        open: false,
        formData: {
          area: [],
          province: [],
          city: [],
          district: [],
          partnerIds: []
        },
        partners: [] //所选省市区下的伙伴
      },
      //地址级联
      area: {
        props: {
          multiple: true
        },
        options: selfAreajs.areaList
      },
      isPartnerIdsShow: true //解决适用范围列表伙伴不反显的问题
    };
  },
  mounted() {
    this.id = this.osg.param('id');
    // 当前用户tenantId
    let acount = JSON.parse(sessionStorage['loginAccount']);
    this.tenantId = acount.tenantId;

    this.osg.getFields('warrantyProduct', () => {
      this.getData();
    });
    this.getLog();
    this.getNote();
    this.getProduct();
  },
  methods: {
    formatProductState(val) {
      return this.osg.codelabel('productState', val);
    },
    pageSizeChange(pageSize) {
      if (this.material.open) {
        this.material.notAddedFpi.rows = pageSize;
        this.getNotAddedMaterials();
      } else {
        this.procedure.fpi.rows = pageSize;
        this.getProcedures();
      }
    },
    pageChange(currentPage) {
      if (this.material.open) {
        this.material.notAddedFpi.page = currentPage;
        this.getNotAddedMaterials();
      } else {
        this.procedure.fpi.page = currentPage;
        this.getProcedures();
      }
    },
    getData() {
      this.osg.ajax(
        `basic/warrantyProduct/findById/${this.id}.do`,
        {},
        res => {
          let row = res.entity;
          row.exts = row.exts || {};
          this.$util.renderExtField(this.extFields, row);
          row = this.$util.deepCopy(row);
          this.formData = row;
          //回显适用范围
          if (row.orgIds && row.partnerIds) {
            this.formData.scope = [
              {
                area: row.exts.area,
                city: row.exts.city,
                district: row.exts.district,
                partnerIds: row.partnerIds,
                orgIds: row.orgIds,
                province: row.exts.province
              }
            ];
          }

          //获取属性修改记录
          this.getHistory();

          // this.getServiceResource(row.orgIds);
          //反显适用范围伙伴列表
          this.querypartnerSearch(row.partnerIds, () => {
            this.$nextTick(() => {
              this.isPartnerIdsShow = true;
              this.$forceUpdate();
            });
          });
        },
        {
          noload: true
        }
      );
    },
    //更改质保年限
    changeYears(val) {
      console.log(val);
      this.driveForm(val);
    },
    // 根据质保年限驱动表单字段
    driveForm(val) {
      let warrantyProductCardData = this.options.warrantyProductCard.find(
        item => item.value == val
      );
      let fixedLifePrice = this.options.fixedLifePrice.find(item => item.label == val).value; //质保卡年限固定价格表
      let warrantyPeriodData = this.options.warrantyPeriod.find(item => item.value == val);
      this.$set(this.formData, 'name', warrantyProductCardData.label);
      this.$set(this.formData.exts, 'nameCode', warrantyProductCardData.value);
      this.$set(this.formData, 'code', val);
      this.$set(this.formData.exts, 'codelabel', warrantyPeriodData.label);
      this.$set(this.formData, 'price', +fixedLifePrice);
      this.$set(this.formData, 'unit', '1');
    },
    async doSave(type) {
      if (this.osg.isRepeatClick('doSave', 5000)) {
        return;
      }
      if (type == 'relative') {
        this.formData.countryUse = this.scope.formData.province.includes('000000') ? '1' : '0'; //是否全国
        this.formData.partnerIds = await this.queryOrgs(this.scope.formData.orgIds); //伙伴ids

        this.formData.exts.area = this.scope.formData.area; //省市区
        this.formData.exts.province = this.scope.formData.province; //省
        this.formData.exts.city = this.scope.formData.city; //市
        this.formData.exts.district = this.scope.formData.district; //区
        this.formData.orgIds = this.scope.formData.orgIds;
      } else if (type == 'delete') {
        delete this.formData.countryUse;
        delete this.formData.partnerIds;

        delete this.formData.exts.area;
        delete this.formData.exts.province;
        delete this.formData.exts.city;
        delete this.formData.exts.district;
        delete this.formData.exts.orgNames;
        delete this.formData.orgIds;
      }
      if (
        (this.osg.validate() && this.osg.validate('formDataDesc')) ||
        type == 'relative' ||
        type == 'delete'
      ) {
        this.$util.saveExtField(this.extFields, this.formData);
        delete this.formData.scope;
        this.formData.exts.promotion = this.formData.exts.promotion || '0';
        this.osg.ajax(
          'basic/warrantyProduct/upsert.do',
          { data: JSON.stringify(this.formData) },
          () => {
            this.doInit();
            this.getData();
            this.osg.toast('保存成功！');
          }
        );
      }
    },
    doInit() {
      this.formData = { exts: {}, productList: [] };
      this.openDetail = false;
      this.scope.open = false;
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getLog() {
      this.log.searchDate = this.log.searchDate || [];
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: this.id,
          smodule: 'warrantyProduct',
          _all: '1',
          'regex:title|string#or': this.log.searchValue,
          'regex:content|string#or': this.log.searchValue,
          'gte:createTime|datetime#and': this.log.searchDate[0],
          'lte:createTime|datetime#and': this.log.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.log.fpi = res;
        },
        { noload: true }
      );
    },
    getHistory() {
      // 其他getFields查询会更新掉表单的fieldsObj
      let fieldsObj = {};
      this.extFields.map(item => {
        if (item.showList && item.showList.indexOf('6') != -1) {
          item.label = item.nameDisp;
          item.value = item.name;
          fieldsObj[item.name] = item;
        }
      });
      this.fieldsObj = fieldsObj;
      this.osg.ajax(
        'biz/changeLog/query.do',
        {
          sid: this.id,
          page: this.historyFpi.page,
          rows: (this.historyFpi.rows += 10)
        },
        res => {
          if (res.data.length > 0) {
            // 不需要展示变更的字段名
            res.data = res.data.filter(item => {
              item.modifyList = item.modifyList.filter(obj => {
                return (
                  this.fieldsObj[obj.field] && this.fieldsObj[obj.field].showList.indexOf('6') != -1
                );
              });
              return item.modifyList.length > 0;
            });
            this.historyFpi = res;
          }
        },
        { noload: true }
      );
    },
    getNote() {
      this.osg.ajax(
        'note/query.do',
        {
          sid: this.id,
          smodule: 'warrantyProduct'
        },
        res => {
          this.noteData = res || [];
        },
        { noload: true }
      );
    },
    saveNote() {
      var params = {
        sid: this.id,
        smodule: 'warrantyProduct',
        content: this.vqeditor.content
      };
      this.osg.ajax('note/upsert.do', params, () => {
        this.openNote = false;
        this.getNote();
      });
    },
    noteMdShow(note) {
      note.openNote = true;
    },
    getProduct(query) {
      let params = {
        _all: '1',
        'regex:name|string#or': query,
        'in:state|array-integer#and': '0,1',
        'ne:productType|string#and': ''
      };
      this.osg.ajax('basic/product/query.do', params, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.product = res.data;
        this.$forceUpdate();
      });
    },
    //获取组织
    queryOrgs(orgIds) {
      return new Promise(resolve => {
        if (Array.isArray(orgIds) && orgIds.length) {
          this.osg.ajax(
            'org/query.do',
            {
              _all: 1,
              'is:state|integer#and': 1,
              'in:_id|array#and': orgIds.join(','),
              notFilterOrgId: '1',
              notFilterBelongTo: '1'
            },
            res => {
              let partnerIds = res.data.orgList.map(item => item.partnerId);
              this.formData.exts.orgNames = res.data.orgList.map(item => item.orgName).join('、');
              resolve(partnerIds);
            },
            {
              noload: true
            }
          );
        } else {
          this.formData.exts.orgNames = [];
          resolve([]);
        }
      });
    },
    // 查询服务资源
    getServiceResource(orgIds) {
      if (Array.isArray(orgIds) && orgIds.length) {
        this.osg.ajax(
          'biz/serviceResource/query.do',
          {
            _all: '1',
            'is:resourceType|string#and': 'partner',
            'in:serviceCrewId|array#and': orgIds.join(',')
          },
          res => {
            res.data.map(item => {
              item.label = item.name;
              item.value = item.serviceCrewId;
            });
            this.options.serviceResource = res.data;
          }
        );
      } else {
        this.options.serviceResource = [];
      }
    },
    //打开适用范围
    openScope() {
      this.cancelScope();
      this.scope.open = true;
    },
    //查询伙伴
    querypartnerSearch(partnerIds, cb) {
      this.isPartnerIdsShow = false;
      if (partnerIds && partnerIds.length) {
        var params = {
          page: 1,
          rows: 49,
          sortField: 'createTime',
          sortOrder: 'desc',
          'in:state|integer#and': 1,
          'in:_id|array#and': partnerIds.join(',')
        };
        this.osg.ajax(
          'basic/partner/query.do',
          params,
          res => {
            this.$set(
              this.options,
              'partners',
              res.data.map(item => {
                item.label = item.name;
                item.value = item._id;
                return item;
              })
            );
            if (cb) cb(res.data);
          },
          { noload: true }
        );
      } else {
        this.options.partners = [];
        if (cb) cb([]);
      }
    },
    formatPartners(row, column, cellValue) {
      return this.osg.codelabelForArray('partners', cellValue);
    },
    addScope() {
      if (
        this.scope.formData.province.indexOf('000000') == -1 &&
        this.scope.formData.orgIds.length == 0
      ) {
        this.osg.toast('请选择伙伴', 'warning');
        return;
      }
      // if (this.scope.index || this.scope.index == 0) {
      //   this.formData.scope[this.scope.index] = this.scope.formData;
      // } else {
      //   this.formData.scope.push(this.scope.formData);
      // }
      if (this.osg.validate('scopeFormData')) {
        this.doSave('relative');
      }
    },
    scopeDelete() {
      this.osg.confirm('是否确认删除适用范围？', () => {
        this.doSave('delete');
      });
    },
    cancelScope() {
      this.scope = {
        open: false,
        formData: {
          area: [],
          province: [],
          city: [],
          district: [],
          partnerIds: []
        },
        partners: []
      };
    },
    /**
     * 适用范围
     */
    async scopeEdit(row, index) {
      this.scope.formData = this.$util.deepCopy(row);
      this.scope.index = index;
      await this.getST(null, true);
      this.scope.open = true;
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    // 查询服务区域
    getST(e, edit) {
      return new Promise(reslove => {
        //下拉框出现/隐藏时触发
        // if (visible) return;
        let area = this.scope.formData.area;
        // 单独存省市区字段
        let province = [],
          city = [],
          district = [];
        for (let arr of area) {
          if (arr[0] && province.indexOf(arr[0]) == -1) province.push(arr[0]);
          if (arr[1] && city.indexOf(arr[1]) == -1) city.push(arr[1]);
          if (arr[2] && district.indexOf(arr[2]) == -1) district.push(arr[2]);
        }
        this.scope.formData.province = province;
        this.scope.formData.city = city;
        this.scope.formData.district = district;

        // //当选择全国时展示所有伙伴
        // if (province.indexOf('000000') != -1) {
        //   this.scope.serviceResource = Object.assign({}, this.options.serviceResource);
        //   this.$forceUpdate();
        //   // return;
        // }
        if (!(province && province.length)) {
          reslove();
          return;
        }
        var params = {
          _all: '1',
          'in:province|array#and': province.toString(),
          'in:city|array#and': city.toString(),
          'in:district|array#and': district.toString()
        };
        this.osg.ajax('basic/serviceTerritory/query.do', params, res => {
          let srIds = [];
          res.data.map(
            item => {
              if (item.relatedIds) {
                srIds = srIds.concat(item.relatedIds);
              }
            },
            {
              noload: true
            }
          );
          this.getPartnersByIds(srIds, serviceCrewIds => {
            if (!edit) {
              // this.scope.formData.orgIds = serviceCrewIds;
              this.$set(this.scope.formData, 'orgIds', serviceCrewIds);
            }
            this.$nextTick(() => {
              this.$forceUpdate();
            });
            reslove();
          });
          // if (srIds.length > 0) {
          //   this.getPartnersByIds(srIds);
          // } else {
          //   this.scope.serviceResource = [];
          // }
        });
      });
    },
    // 查询服务区域下的伙伴
    getPartnersByIds(ids, cb) {
      if (ids && ids.length) {
        var params = {
          _all: '1',
          'in:_id|array#and': ids.toString(),
          'is:resourceType|string#and': 'partner',
          'in:state|array-integer#and': '1',
          sortField: 'createTime',
          sortOrder: 'desc'
        };
        this.osg.ajax(
          'biz/serviceResource/query.do',
          params,
          res => {
            let serviceCrewIds = [];
            res.data.map(item => {
              item.label = item.name;
              item.value = item.serviceCrewId;
              serviceCrewIds.push(item.serviceCrewId);
            });
            this.scope.serviceResource = res.data;

            this.$forceUpdate();
            if (cb) cb(serviceCrewIds);
          },
          {
            noload: true
          }
        );
      } else {
        this.scope.serviceResource = [];
        this.scope.formData.orgIds = [];
        if (cb) cb();
      }
    },
    formatProvinces(value) {
      let str = '';
      for (var item of value) {
        str += selfAreaList.province_list[item] + '、';
      }
      return str.substring(0, str.length - 1);
    },
    formatCitys(value) {
      let str = '';
      for (var item of value) {
        str += selfAreaList.city_list[item] + '、';
      }
      return str.substring(0, str.length - 1);
    },
    formatDistricts(value) {
      let str = '';
      for (var item of value) {
        str += selfAreaList.county_list[item] + '、';
      }
      return str.substring(0, str.length - 1);
    },
    // 点击标签栏
    tabClick() {
      // switch (tab.name) {
      //   case 'procedure':
      //     this.getAddedProcedures();
      //     break;
      //   default:
      // }
    }
  },
  watch: {
    // laborCost() {
    //   this.formData.cost = this.laborCost;
    // },
    // laborFee() {
    //   this.formData.price = this.laborFee;
    // }
  }
};
</script>
<style lang="scss">
.product .c-dialog {
  min-width: 1000px !important;
}
.c-min-height-80vh {
  min-height: 80vh;
}
.product .c-dialog.c-min-width-600 {
  min-width: 600px !important;
}
.c-radio-group {
  display: flex !important;
}
</style>
